import type { CarbonReport } from "@/mocks/carbono";

interface CarbonReportsGridProps {
  reports: CarbonReport[];
}

export default function CarbonReportsGrid({ reports }: CarbonReportsGridProps) {
  const getStatusConfig = (status: string, lastGenerated: string | null) => {
    if (status === "gerando") {
      return {
        bg: "bg-caution-50",
        text: "text-caution-700",
        border: "border-caution-200",
        icon: "ri-loader-4-line",
        label: "Gerando...",
      };
    }
    if (status === "pendente" || !lastGenerated) {
      return {
        bg: "bg-warning-50",
        text: "text-warning-700",
        border: "border-warning-200",
        icon: "ri-time-line",
        label: "Pendente",
      };
    }
    return {
      bg: "bg-primary-50",
      text: "text-primary-700",
      border: "border-primary-200",
      icon: "ri-check-line",
      label: `Gerado ${lastGenerated}`,
    };
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {reports.map((report) => {
        const cfg = getStatusConfig(report.status, report.lastGenerated);
        return (
          <div
            key={report.id}
            className="bg-white rounded-xl border border-background-200/70 p-5 hover:-translate-y-1 hover:border-primary-300/70 transition-all duration-300"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="w-9 h-9 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className="ri-file-chart-line text-accent-600 w-full h-full flex items-center justify-center text-lg" />
              </div>
              <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium border ${cfg.bg} ${cfg.text} ${cfg.border}`}>
                <i className={`${cfg.icon} w-3 h-3 flex items-center justify-center`} />
                {cfg.label}
              </span>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 leading-tight mb-1">{report.title}</h3>
            <p className="text-xs text-foreground-500 mb-4 line-clamp-2">{report.description}</p>
            <div className="text-[11px] text-foreground-400 mb-3">Formato: {report.format}</div>
            <div className="flex gap-2">
              <button className="flex-1 px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 rounded-md hover:bg-primary-100 transition-colors whitespace-nowrap">
                Gerar
              </button>
              {report.lastGenerated && (
                <>
                  <button className="flex-1 px-3 py-1.5 text-xs font-medium text-accent-700 bg-accent-50 rounded-md hover:bg-accent-100 transition-colors whitespace-nowrap">
                    Visualizar
                  </button>
                  <button className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-50 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap">
                    Exportar
                  </button>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}